import { Box } from "@bcc-ui/ui-components";
import React from "react";

import testIds from "testIds.json";

export const ReportsTab = () => {
    return <Box testId={testIds.workArea.asset.customView.reports.itself}>TODO: Implement Reports tab content</Box>;
};
